<div class="tape" [class.tape--collapsed]="collapsed">
  <div class="tape-label">THE TAPE</div>
  <div class="tape-track">
    @for (entry of tapePlayers(); track entry.draft_position) {
      <div class="tape-card-wrap">
        <div class="tape-pick">{{ entry.team_name }}</div>
        <app-player-card [player]="cardData(entry)" [nameAbbrev]="true" [showPhoto]="false"></app-player-card>
        @if (isCommissioner()) {
          <button class="undraft-btn" (click)="undraftPlayer(entry)" title="Undraft player">
            <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
              <line x1="18" y1="6" x2="6" y2="18"></line>
              <line x1="6" y1="6" x2="18" y2="18"></line>
            </svg>
          </button>
        }
      </div>
    }
    @empty {
      <div class="tape-empty">No picks yet</div>
    }
  </div>
</div>
